import View from "components/elements/View";
import { useGetHealthQuery } from "store/healthcheck";

function HealthCheck(): JSX.Element {
  const isHealthy = useGetHealthQuery();

  return (
    <View>
      <div>
        IsHealthy: {isHealthy?.isSuccess && isHealthy?.data ? "true" : "false"}
      </div>
    </View>
  );
}

export default HealthCheck;
